var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[_c('v-btn',{directives:[{name:"has-perms",rawName:"v-has-perms",value:(_vm.perms),expression:"perms"}],key:"add",staticClass:"mb-5",attrs:{"color":"accent","fab":"","fixed":"","bottom":"","right":""},on:{"click":_vm.addToList}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" add ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }